import React from 'react'

export type TextProps = {
  id?: string
  children: React.ReactNode
  as?: keyof React.JSX.IntrinsicElements
  htmlFor?: string
  className?: string
  style?: React.CSSProperties
  role?: string
}

const Text: React.FC<TextProps> = ({
  id,
  children,
  as: Component = 'span',
  className = '',
  htmlFor = '',
  style = {},
  ...props
}) => (
  <Component id={id} htmlFor={htmlFor} className={className} style={style} {...props}>
    {children}
  </Component>
)

export default Text
